import React from 'react'

const StyledXsText = ({ children, fontColor }) => {
    return (
        <p className={`text-xs font-medium font-dmsans ${fontColor}`}>{children}</p>
    )
}

export default StyledXsText
